import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home,
  Briefcase,
  Wallet,
  MessageSquare,
  Bot
} from 'lucide-react';

const LawyerBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: Home,
      path: '/lawyer-dashboard'
    },
    {
      id: 'cases',
      label: 'Cases',
      icon: Briefcase,
      path: '/lawyer-cases'
    },
    {
      id: 'ai-assistant',
      label: 'AI Assistant',
      icon: Bot,
      path: '/lawyer-ai-assistant'
    },
    {
      id: 'chats',
      label: 'Chats',
      icon: MessageSquare,
      path: '/lawyer-chats'
    },
    {
      id: 'wallet',
      label: 'Wallet',
      icon: Wallet,
      path: '/lawyer-wallet'
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = (path) => {
    navigate(path);
  };

  return (
    <div className="bottom-nav">
      <div className="bottom-nav-content">
        <div className="bottom-nav-items">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            return (
              <motion.button
                key={item.id}
                onClick={() => handleNavClick(item.path)}
                className={`bottom-nav-item ${
                  active 
                    ? 'active' 
                    : ''
                }`}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <Icon 
                  className="w-5 h-5" 
                />
                <span className="text-xs font-medium leading-tight">
                  {item.label}
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LawyerBottomNav;
